<template>
  <footer class="c-footer">
    <div class="c-footer_grid">
      <div class="c-footer_brandWrap">
        <img class="c-footer_logo" :src="require('img/logo-nocolor-flat.png')" width="45" height="50" alt="Logo do CoteiBem" title="CoteiBem">
      </div>

      <nav class="c-footer_linkWrap">
        <a :href="routes.account.login" class="c-footer_link" v-if="!isAuthenticated">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" v-bind:class="'c-footer_link_icon'" v-bind:svg-inline="''" v-bind:title="'Entrar'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g data-name="Grupo de máscara 1685"><g data-name="streamline-icon-interface-login@20x20"><path data-name="Caminho 3224" class="cls-3" d="M12 20H2a2 2 0 01-2-2V2a2 2 0 012-2h10a2 2 0 012 2v3.846a1 1 0 01-2 0V2H2v16h10v-3.846a1 1 0 112 0V18a2 2 0 01-2 2z"/><path data-name="Caminho 3225" class="cls-3" d="M19 11H7a1 1 0 010-2h12a1 1 0 010 2z"/><path data-name="Caminho 3226" class="cls-3" d="M10 14a1 1 0 01-.707-.293l-3-3a1 1 0 010-1.414l3-3a1 1 0 111.414 1.414L8.414 10l2.293 2.293A1 1 0 0110 14z"/></g></g></svg>
          Entrar
        </a>
        <a href="/anuncie" class="c-footer_link" v-if="!isAuthenticated">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" v-bind:class="'c-footer_link_icon'" v-bind:svg-inline="''" v-bind:title="'Seja um fornecedor'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g data-name="Grupo de máscara 1686"><g data-name="streamline-icon-interface-share-mega-phone-1@20x20"><path data-name="Caminho 3221" class="cls-3" d="M18.306 18.094a1.69 1.69 0 01-.547-.091h-.008L1.6 12.329A2.4 2.4 0 010 10.042V8.535a2.4 2.4 0 011.6-2.272L17.75.585h.009A1.694 1.694 0 0120 2.185v14.192a1.694 1.694 0 01-1.694 1.718zM18 2.614L2.264 8.148A.4.4 0 002 8.527v1.533a.4.4 0 00.266.382L18 15.968z"/><path data-name="Caminho 3222" class="cls-3" d="M7.678 19.512a5.79 5.79 0 01-5.233-8.015 1 1 0 111.846.77A3.758 3.758 0 004 13.729v.025a3.672 3.672 0 007.231.986 1 1 0 011.939.491 5.668 5.668 0 01-5.492 4.281z"/><path data-name="Caminho 3223" class="cls-3" d="M14 16.621a1 1 0 01-1-1V2.959a1 1 0 012 0v12.662a1 1 0 01-1 1z"/></g></g></svg>
          Seja um fornecedor
        </a>
        <a :href="routes.landing.usage" class="c-footer_link">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" v-bind:class="'c-footer_link_icon'" v-bind:svg-inline="''" v-bind:title="'Privacidade de uso'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g data-name="Grupo de máscara 1687"><g data-name="streamline-icon-interface-edit-pen-1@20x20"><path data-name="Caminho 3202" class="cls-3" d="M5 19.178a2.965 2.965 0 01-2.106-.87l-1.2-1.2a2.99 2.99 0 010-4.213L13.465 1.121a3.829 3.829 0 015.415 5.414L7.107 18.307A2.966 2.966 0 015 19.178zM16.172 2a1.818 1.818 0 00-1.293.535L3.107 14.307a.986.986 0 000 1.387l1.2 1.2a.984.984 0 001.387 0L17.465 5.121A1.828 1.828 0 0016.172 2z"/><path data-name="Caminho 3203" class="cls-3" d="M1 20a1 1 0 01-.707-1.707l2-2a1 1 0 011.414 1.414l-2 2A1 1 0 011 20z"/><path data-name="Caminho 3204" class="cls-3" d="M15 10a1 1 0 01-.707-.293l-5.6-5.6a1 1 0 00-1.394 0l-4.6 4.6a1 1 0 01-1.406-1.414l4.6-4.6.007-.007a3 3 0 014.2 0l.007.007 5.6 5.6A1 1 0 0115 10z"/></g></g></svg>
          Termos de uso
        </a>
        <a href="https://www.sindiconet.com.br/portalsindiconet/privacidade" target="_blank" class="c-footer_link">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" v-bind:class="'c-footer_link_icon'" v-bind:svg-inline="''" v-bind:title="'Privacidade de uso'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g data-name="Grupo de máscara 1688"><g data-name="streamline-icon-interface-edit-view@20x20"><path data-name="Caminho 3205" class="cls-3" d="M10 4h.1a13.97 13.97 0 019.28 4.875 2.34 2.34 0 01-.017 3.192C17.653 13.911 14.167 17 10 17S2.347 13.911.638 12.067A2.34 2.34 0 01.62 8.875 13.97 13.97 0 019.9 4h.1zm0 11c3.537 0 6.7-3 7.9-4.3l.008-.008a.34.34 0 000-.468l-.038-.043A11.907 11.907 0 0010 6.005a11.907 11.907 0 00-7.868 4.18l-.038.043a.34.34 0 000 .468l.006.004C3.3 12 6.463 15 10 15z"/><path data-name="Caminho 3206" class="cls-3" d="M10 7a3.5 3.5 0 11-3.5 3.5A3.5 3.5 0 0110 7zm0 5a1.5 1.5 0 10-1.5-1.5A1.5 1.5 0 0010 12z"/></g></g></svg>
          Políticas de privacidade
        </a>
        <a :href="routes.landing.about" class="c-footer_link">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" v-bind:class="'c-footer_link_icon'" v-bind:svg-inline="''" v-bind:title="'Quem somos'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g data-name="Grupo de máscara 1689"><g data-name="streamline-icon-interface-user-multiple@20x20"><path data-name="Caminho 3217" class="cls-3" d="M7 0a4.5 4.5 0 11-4.5 4.5A4.505 4.505 0 017 0zm0 7a2.5 2.5 0 10-2.5-2.5A2.5 2.5 0 007 7z"/><path data-name="Caminho 3218" class="cls-3" d="M13 20H1a1 1 0 01-1-1v-2a7 7 0 0114 0v2a1 1 0 01-1 1zM2 18h10v-1a5 5 0 00-10 0z"/><path data-name="Caminho 3219" class="cls-3" d="M14.737 8.54a1 1 0 01-.5-1.868 2.5 2.5 0 00.321-4.125A1.001 1.001 0 0115.811.985a4.5 4.5 0 01-.579 7.423 1 1 0 01-.495.132z"/><path data-name="Caminho 3220" class="cls-3" d="M19 20h-2a1 1 0 010-2h1v-1a5.025 5.025 0 00-2.427-4.289A1 1 0 0116.6 11a7 7 0 013.4 6v2a1 1 0 01-1 1z"/></g></g></svg>
          Quem somos
        </a>
        <a :href="routes.landing.support" class="c-footer_link">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" v-bind:class="'c-footer_link_icon'" v-bind:svg-inline="''" v-bind:title="'Ajuda'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g data-name="Grupo de máscara 1690"><g data-name="streamline-icon-interface-help-customer-support-human-2@20x20"><path data-name="Caminho 3211" class="cls-3" d="M9.501 5a4 4 0 11-4 4 4 4 0 014-4zm0 6a2 2 0 10-2-2 2 2 0 002 2z"/><path data-name="Caminho 3212" class="cls-3" d="M9.501 7a1 1 0 01-1-1V1a1 1 0 012 0v5a1 1 0 01-1 1z"/><path data-name="Caminho 3213" class="cls-3" d="M17.501 12a1 1 0 01-1-1V9.344a7.5 7.5 0 00-3.529-6.389 1.001 1.001 0 011.058-1.7 9.5 9.5 0 014.471 8.092V11a1 1 0 01-1 1z"/><path data-name="Caminho 3214" class="cls-3" d="M13.501 20a1 1 0 01-1-1v-1a1 1 0 012 0v1a1 1 0 01-1 1z"/><path data-name="Caminho 3215" class="cls-3" d="M5.501 20a1 1 0 01-1-1v-2.515a9 9 0 01.5-15.285 1.002 1.002 0 111 1.736 7 7 0 000 12.128 1 1 0 01.5.866V19a1 1 0 01-1 1z"/><path data-name="Caminho 3216" class="cls-3" d="M18.501 16a1 1 0 01-.219-.024l-5.1-1.138a5.963 5.963 0 01-3.6-2.4 1 1 0 111.637-1.149 3.969 3.969 0 002.4 1.6l5.1 1.138A1 1 0 0118.501 16z"/></g></g></svg>
          Central de ajuda
        </a>
      </nav>

      <div class="c-footer_socialWrap">
        <a class="c-footer_socialLink" href="https://www.facebook.com/sindiconet/" target="_blank" rel="noopener noreferrer">
          <svg data-name="Grupo 3281" xmlns="http://www.w3.org/2000/svg" width="37.97" height="37.97" viewBox="0 0 37.97 37.97" v-bind:class="'c-footer_socialIcon'" v-bind:svg-inline="''" v-bind:title="'Facebook SíndicoNet'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path data-name="Caminho 406" class="cls-1" d="M37.97 8.137A8.627 8.627 0 0030.076 0H7.428C5.124 0 .064 3.2 0 8.19v21.747c.009 4.943 5.124 8.03 7.428 8.033h10.22a.677.677 0 00.677-.679V24.442a.676.676 0 00-.677-.677h-1.063a1.668 1.668 0 01-1.667-1.665v-2.074a1.668 1.668 0 011.664-1.671h1.066a.677.677 0 00.677-.677v-2.49a6.291 6.291 0 016.483-7.051c.574 0 1.88.035 3.118.054a1.666 1.666 0 011.628 1.668v2.019A1.668 1.668 0 0127.9 13.56h-1.321c-1.03 0-2.065 0-2.065 2.277v1.857a.679.679 0 00.679.679h1.248a1.67 1.67 0 011.668 1.671v2.069a1.668 1.668 0 01-1.668 1.668h-1.248a.678.678 0 00-.679.677v12.833a.679.679 0 00.679.679h4.883a8.661 8.661 0 007.894-8.033z"/></svg>
        </a>
        <a class="c-footer_socialLink" href="https://www.instagram.com/coteibem/" target="_blank" rel="noopener noreferrer">
          <svg data-name="Grupo 3281" xmlns="http://www.w3.org/2000/svg" width="37.97" height="37.97" viewBox="0 0 37.97 37.97" v-bind:class="'c-footer_socialIcon'" v-bind:svg-inline="''" v-bind:title="'Instagram'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path data-name="Caminho 404" class="cls-1" d="M29.269 0H8.7A8.717 8.717 0 000 8.7v20.569a8.717 8.717 0 008.7 8.7h20.569a8.717 8.717 0 008.7-8.7V8.7a8.717 8.717 0 00-8.7-8.7zm2.373 25.313a6.328 6.328 0 01-6.328 6.328H12.657a6.328 6.328 0 01-6.328-6.328V12.657a6.328 6.328 0 016.328-6.328h12.656a6.328 6.328 0 016.328 6.328z"/><circle data-name="Elipse 19" class="cls-1" cx="6" cy="6" r="6" transform="translate(13.045 13)"/><ellipse data-name="Elipse 20" class="cls-1" cx="1.5" cy="2" rx="1.5" ry="2" transform="translate(25.045 9)"/></svg>
        </a>
        <a class="c-footer_socialLink" href="https://twitter.com/sindiconet/" target="_blank" rel="noopener noreferrer">
          <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" v-bind:class="'c-footer_socialIcon'" v-bind:svg-inline="''" v-bind:title="'Twitter SíndicoNet'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g data-name="Grupo 3982"><path data-name="Exclusão 2" class="cls-1" d="M29.29 38H8.708A8.74 8.74 0 010 29.292V8.708A8.74 8.74 0 018.708 0H29.29A8.742 8.742 0 0138 8.708v20.584A8.742 8.742 0 0129.29 38zM7.147 26.006a.547.547 0 00-.455.851.543.543 0 00.349.232 21.223 21.223 0 008.733 2.071h.2a13.488 13.488 0 007.311-2.148A13.355 13.355 0 0029.25 15.82v-.934a.524.524 0 01.194-.407l1.76-1.471a.536.536 0 00-.215-.933l-.848-.2a.524.524 0 01-.353-.3.532.532 0 010-.462l.482-.955a.536.536 0 00-.632-.751l-2.147.6a.516.516 0 01-.137.019.509.509 0 01-.323-.115 5.366 5.366 0 00-5.618-.511 5.337 5.337 0 00-2.967 4.8v.386a.268.268 0 01-.234.269 7.158 7.158 0 01-.84.05c-2.687 0-5.361-1.575-8.175-4.815a.533.533 0 00-.408-.19.518.518 0 00-.14.019.528.528 0 00-.322.471 8.1 8.1 0 00.494 5.28.293.293 0 010 .28.259.259 0 01-.213.113.25.25 0 01-.056-.006l-1.213-.236a.52.52 0 00-.073 0 .559.559 0 00-.4.166.553.553 0 00-.139.472 5.5 5.5 0 002.543 4.057.266.266 0 01.128.247.257.257 0 01-.159.237l-.579.225a.574.574 0 00-.3.311.548.548 0 000 .43 4.679 4.679 0 003.433 2.661.293.293 0 01.206.237.282.282 0 01-.162.279 11.772 11.772 0 01-4.475.879h-.108a.53.53 0 00-.107-.016z"/></g></svg>
        </a>
      </div>

      <div class="c-footer_press">
        <p class="c-footer_contact">Administradoras, parcerias e imprensa:</p>
        <p class="c-footer_email">contato@coteibem.com.br</p>
      </div>
    </div>

    <div class="c-footer_disclaimer">
      <hr class="c-footer_disclaimerHR">
      <p class="c-footer_disclaimerParagraph">
        Aviso importante:
      </p>
      <p class="c-footer_disclaimerParagraph">
        O CoteiBem SíndicoNet é apenas uma plataforma de aproximação, e não oferece quaisquer garantias, implícitas ou explicitas,
        sobre os produtos e serviços disponibilizados neste site. Assim, o CoteiBem SíndicoNet não se responsabiliza, a qualquer
        título, pelos serviços ou produtos comercializados pelos fornecedores listados neste site, sendo sua contratação por
        conta e risco do usuário, que fica ciente que todos os eventuais danos ou prejuízos, de qualquer natureza, que possam
        decorrer da contratação/aquisição dos serviços e produtos listados neste site são de responsabilidade exclusiva do
        fornecedor contratado, sem qualquer solidariedade ou subsidiariedade do CoteiBem SíndicoNet.
      </p>
      <p class="c-footer_disclaimerParagraph">
        Para saber mais, acesse nossos <a class="c-footer_disclaimerLink" :href="routes.landing.usage">Termos de Uso</a>.
      </p>
    </div>

    <aside class="c-footer_copyright">
      Copyright {{ currentYear }} - CoteiBem e SíndicoNet - Todos os direitos reservados. Reprodução Proibida.
    </aside>
  </footer>
</template>

<script>
import startOfToday from 'date-fns__legacy__/start_of_today'
import getYear from 'date-fns__legacy__/get_year'
import { account, landing } from 'routes'
import { mapState } from 'vuex'

const initialState = () => ({
  currentYear: 0,
  routes: {
    account,
    landing,
  }
})

export default {
  created() {
    const today = startOfToday()
    const todayYear = getYear(today)

    this.currentYear = todayYear
  },

  data() {
    return initialState()
  },

  computed: {
    ...mapState({
      isAuthenticated: state => state.account.authenticated,
    })
  }
}
</script>

<style lang="scss">
@import "~css/_references";

.c-footer {
  background-color: $v-colorGray-dark;
  padding: $v-gap-sml $v-gap-sm;

  @include f-media('>=tablet') {
    padding: $v-gap-lg $v-gap-sm;
  }

  &_disclaimerParagraph {
    color: rgba(255, 255, 255, .75);
  }

  &_disclaimer {
    max-width: $v-screen-container;
    margin: $v-gap-md auto;

    &HR {
      border: none;
      border-top: 1px solid rgba($v-colorWhite, .1);
      margin-bottom: $v-gap-md;
    }

    &Title, &Paragraph {
      color: rgba($v-colorWhite, .75);
      line-height: 1.5;
    }


    &Title {
      font-weight: $v-fontWeight-semibold;
      text-transform: uppercase;
      font-size: $v-font-xxs;
      margin-bottom: $v-gap-sm;
    }

    &Paragraph {
      margin-bottom: $v-gap-sm;
      font-size: 13px;
    }

    &Link {
      color: $v-colorWhite;
      &:hover, &:active, &:visited {
        color: $v-colorWhite;
      }
    }
  }

  &_grid {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: $v-gap-mdl;
    max-width: $v-screen-container;
    margin: 0 auto;

    @include f-media('>=tablet') {
      grid-template-columns: 50px 8fr 2fr;
    }

    @include f-media('<tablet') {
      justify-items: center;
    }
  }

  &_press {
    @include f-media('>=tablet') {
      grid-area: 2 / 2 / 3 / 3;
    }
    @include f-media('<tablet') {
      text-align: center;
    }
  }

  &_contact {
    color: rgba($v-colorWhite, .75);
    margin-bottom: 8px;
  }

  &_email {
    color: $v-colorYellow-dark-1;
  }
  &_brandWrap,
  &_linkWrap,
  &_socialWrap {
    color: $v-colorWhite;
    align-self: center;

    @include f-media('<tablet') {
      text-align: center;
    }
  }

  &_brandWrap {
    content: ''
  }

  &_linkWrap {
    @include f-media('>=tablet') {
      columns: 2;
      column-gap: $v-gap-sm;
    }

    @include f-media('>=desktop') {
      columns: 3;
    }
  }

  &_socialWrap {
    display: grid;
    grid-template-columns: 40px 40px 40px;
    grid-gap: $v-gap-mdl;
    justify-content: end;

    @include f-media('>=tablet') {
      grid-gap: $v-gap-sm;
    }
  }

  &_logo {
    fill: $v-colorYellow-dark-1;
    width: auto;
    height: 50px;
  }

  &_link {
    display: flex;
    flex-direction: row;
    align-content: center;
    align-items: center;
    color: $v-colorWhite;
    line-height: 2.4;

    @include f-media('<tablet') {
      justify-content: center;
    }

    &_icon {
      width: 20px;
      height: 20px;
      min-width: 20px;
      min-height: 20px;
      fill: $v-colorWhite;
      margin-right: $v-gap-xs;
    }
  }

  &_socialIcon {
    fill: white;
    width: auto;
    height: 40px;
    opacity: .4;
    transition: opacity $v-duration-leave $v-easing-swift-out;

    @include f-media('<tablet') {
      height: 40px;
    }
  }

  &_socialLink {
    line-height: 0;

    &:hover, &:active {
      > .c-footer_socialIcon {
        opacity: .75;
      }
    }
  }

  &_copyright {
    margin-top: $v-gap-lg;
    font-size: $v-font-xxs;
    text-align: center;
    color: rgba($v-colorWhite, .75);
    line-height: 1.4;
  }

}
</style>